const semanticClassNames = {
  root: 'social-player-tiktok',
} as const;

export default semanticClassNames;
